import { RefCallBack } from "react-hook-form";

export const hexToRgba = (hexString: string, a: number) => {
  let hex = hexString;
  if (hex.charAt(0) === "#") hex = hex.substring(1, hex.length);
  return `rgba(
    ${parseInt(hex.substring(0, 2), 16)}, 
    ${parseInt(hex.substring(2, 4), 16)}, 
    ${parseInt(hex.substring(4, 6), 16)}, 
    ${a})`;
};

export const mapRefToInputRef = (useFormRegisterReturn: {
  ref: RefCallBack;
  [x: string]: unknown;
}) => {
  const { ref, ...rest } = useFormRegisterReturn;
  return {
    inputRef: ref,
    ...rest,
  };
};
